module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h3', [_vm._v("Starbase Router")]), _vm._v(" "), _c('h4', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/data/people"
    }
  }, [_vm._v("Meet the chatacters")]), _vm._v(" | \n    "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/data/planets"
    }
  }, [_vm._v("Explore the planets")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7f2810","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 9
// module chunks = 0